import { useState } from "react";

let Temp = () => {
  let [valRange, setValRange] = useState(0);

  let handleChanger = () => {};

  return (
    <div
      className="main-div-changer"
      style={{ backgroundColor: `rgb(${valRange}, 188, 167)` }}
    >
      <span>Temp</span>
      <div>
        <input
          onChange={(e) => setValRange(e.target.value)}
          type="range"
          min="0"
          max="100"
          name="range1"
        ></input>
        <label>{valRange} </label>
      </div>
    </div>
  );
};

export default Temp;
